import { useContext } from 'react';

import { Ctx, TContextDispatch } from '@r1-frontend/entities/ConnectDomruPopup/context';

export const useContextDispatch = (): TContextDispatch => {
    const { dispatch } = useContext(Ctx);
    return dispatch;
};
